import { Component, computed, input, model } from '@angular/core';
import { CoreModule } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { Offer } from '../../../../services/offers/offer.model';
import { ImageCarouselComponent } from '../image-carousel/image-carousel.component';

@Component({
	selector: 'ivva-images-header',
	templateUrl: './images-header.component.html',
	styleUrls: ['./images-header.component.scss'],
	imports: [CoreModule, TranslateModule, ImageCarouselComponent],
})
export class ImagesHeaderComponent {
	offer = input.required<Offer>();
	indexImageCarousel = model<number | null>(null);

	allImages = computed(() => {
		const o = this.offer();

		if (o) {
			return o.poster ? [o.poster, ...o.images] : o.images;
		}

		return [];
	});
}
